import { render, staticRenderFns } from "./chanpinku_info.vue?vue&type=template&id=7d0dacab&"
import script from "./chanpinku_info.vue?vue&type=script&lang=js&"
export * from "./chanpinku_info.vue?vue&type=script&lang=js&"
import style0 from "./chanpinku_info.vue?vue&type=style&index=0&id=7d0dacab&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports